/**
 * 404 Not Found Page
 */

import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600">
            <div className="text-center px-4">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-white opacity-20">404</h1>
                    <h2 className="text-4xl font-bold text-white mb-4">Page Not Found</h2>
                    <p className="text-xl text-white opacity-90 mb-8">
                        Oops! The page you're looking for doesn't exist.
                    </p>
                </div>

                <div className="flex gap-4 justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 px-6 py-3 bg-white text-indigo-600 rounded-lg font-medium hover:shadow-lg transition-all"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Go Back
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="flex items-center gap-2 px-6 py-3 bg-indigo-500 text-white rounded-lg font-medium hover:bg-indigo-400 hover:shadow-lg transition-all"
                    >
                        <Home className="w-5 h-5" />
                        Home Page
                    </button>
                </div>
            </div>
        </div>
    );
}
